import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuWorkspaceMembershipTypeAppResource from './LuWorkspaceMembershipTypeAppResource';
import MLSAppResource from './MLSAppResource';
import MarketAppResource from './MarketAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PlaybookAppResource from './PlaybookAppResource';
import UserAppResource from './UserAppResource';

class LandingPageSettingsAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-settings';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/settings';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'userUuid',
      'organizationUuid',
      'projectMembershipTypeUuid',
      'homePurchasePlaybookUuid',
      'homeSalePlaybookUuid',
      'homeOwnershipPlaybookUuid',
      'state',
      'marketUuid',
      'mlsUuid',
      'hasBuy',
      'hasSell',
      'hasFinance',
      'hasTrade',
      'hasLearn',
      'user',
      'organization',
      'projectMemberType',
      'homePurchasePlaybook',
      'homeSalePlaybook',
      'homeOwnershipPlaybook',
      'market',
      'mls',
      'knowledgeBaseUuid',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
      organization: OrganizationAppResource,
      projectMemberType: LuWorkspaceMembershipTypeAppResource,
      homePurchasePlaybook: PlaybookAppResource,
      homeSalePlaybook: PlaybookAppResource,
      homeOwnershipPlaybook: PlaybookAppResource,
      market: MarketAppResource,
      mls: MLSAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: 'user_uuid',
      organization: 'organization_uuid',
      projectMemberType: 'project_membership_type_uuid',
      homePurchasePlaybook: 'home_purchase_playbook_uuid',
      homeSalePlaybook: 'home_sale_playbook_uuid',
      homeOwnershipPlaybook: 'home_ownership_playbook_uuid',
      market: 'market_uuid',
      mls: 'mls_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      userUuid: {
        type: 'string',
        presence: true,
      },
      organizationUuid: {
        type: 'string',
        presence: true,
      },
      projectMembershipTypeUuid: {
        type: 'string',
        presence: true,
      },
      homePurchasePlaybookUuid: {
        type: 'string',
      },
      homeSalePlaybookUuid: {
        type: 'string',
      },
      homeOwnershipPlaybookUuid: {
        type: 'string',
        presence: true,
      },
      state: {
        type: 'string',
        length: {
          maximum: 2,
        },
      },
      marketUuid: {
        type: 'string',
      },
      mlsUuid: {
        type: 'string',
      },
      hasBuy: {
        type: 'boolean',
      },
      hasSell: {
        type: 'boolean',
        presence: true,
      },
      hasFinance: {
        type: 'boolean',
        presence: true,
      },
      hasTrade: {
        type: 'boolean',
        presence: true,
      },
      hasLearn: {
        type: 'boolean',
        presence: false,
      },
      knowledgeBaseUuid: {
        type: 'string',
      }
    };
  }

}

export default LandingPageSettingsAppResource;
